import { useCallback } from "react";
import { useNavigate } from "react-router";

import Box from "ds/components/Box";
import Button from "ds/components/Button";
import { External, MessageBubble } from "components/icons/generated";
import ButtonIcon from "ds/components/ButtonIcon";

import styles from "./styles.module.css";
import useAssistantPanelStore from "../Layout/useStore";
import useAssistantPanelLearnStore from "./useStore";
import AssistantPanelLayoutHeader from "../Layout/Header";
import AssistantPanelLearnChaptersView from "./components/ChaptersView";
import AssistantPanelLearnGroupsView from "./components/GroupsView";
import AssistantPanelLearnActiveGuideView from "./components/ActiveGuideView";
import AssistantPanelLearnNavigationBackButton from "./components/NavigationBackButton";
import AssistantPanelLearnMissionHeaderTitle from "./components/MissionHeaderTitle";
import AssistantPanelLayoutHeaderActions from "../Layout/Header/Actions";
import AssistantPanelLayoutHeaderModeDropdown from "../Layout/Header/ModeDropdown";
import useAssistantPanelAvailableViews from "../hooks/useAvailableViews";
import { AssistantPanelView } from "../Layout/types";
import useIsAssistantPageMode from "../hooks/useIsAssistantPageMode";

const AssistantPanelLearn = () => {
  const navigate = useNavigate();
  const isAssistantPageMode = useIsAssistantPageMode();
  const { setIsOpen } = useAssistantPanelStore();
  const { navigationState } = useAssistantPanelLearnStore();
  const availableViews = useAssistantPanelAvailableViews();
  const hasChatView = availableViews.includes(AssistantPanelView.CHAT);

  const switchView = useAssistantPanelStore((state) => state.switchView);

  const handleSwitchToAiChat = useCallback(() => {
    switchView(AssistantPanelView.CHAT);
  }, [switchView]);

  const handleGoToDashboard = useCallback(() => {
    if (!isAssistantPageMode) {
      setIsOpen(false);
    }
    navigate("/launchpad");
  }, [navigate, setIsOpen, isAssistantPageMode]);

  return (
    <>
      <AssistantPanelLayoutHeader>
        <Box fullWidth align="center" gap="medium" gridTemplate="1fr auto 1fr" grid>
          <Box align="center" className={styles.headerSide}>
            <AssistantPanelLearnNavigationBackButton />
          </Box>
          <Box direction="column">
            <AssistantPanelLearnMissionHeaderTitle />
          </Box>
          <Box justify="end" gap="medium" className={styles.headerSide}>
            {hasChatView && (
              <ButtonIcon
                icon={MessageBubble}
                variant="ghost"
                size="small"
                onPress={handleSwitchToAiChat}
              >
                Switch to AI chat
              </ButtonIcon>
            )}
            {!isAssistantPageMode && <AssistantPanelLayoutHeaderModeDropdown />}
            <AssistantPanelLayoutHeaderActions />
          </Box>
        </Box>
      </AssistantPanelLayoutHeader>

      {navigationState.level === "groups" && <AssistantPanelLearnGroupsView />}
      {navigationState.level === "chapters" && <AssistantPanelLearnChaptersView />}
      {navigationState.level === "guide" && <AssistantPanelLearnActiveGuideView />}

      <Box direction="column" padding="x-large">
        <Box
          align="center"
          justify="center"
          gap="medium"
          padding="x-large 0 0 0"
          className={styles.dashboardLink}
        >
          <Button variant="ghost" size="small" endIcon={External} onPress={handleGoToDashboard}>
            View full learning dashboard
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default AssistantPanelLearn;
